import { useState, useContext, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { AdminContext } from "../../context/adminContext";
import Loader from "../../UI/Loader/Loader";
import CoveredBackground from "../../UI/СoveredBackground/СoveredBackground";
import ErrorMessage from "../../UI/ErrorMessage/ErrorMessage";

import ButtonBack from "../../UI/ButtonBack/ButtonBack";
 

const ResultPage = () => {

  const params = useParams();
  const { getCategoryById } = useContext(AdminContext);
  const [results, setResults] = useState(null);
  
  const [error, setError] = useState();
  const [search, setSearch] = useState("");
  const [searchChecker, setSearchChecker] = useState(null)

  const searchHandler = () => {
    if (search.length > 2) {

      setResults(null)
      setSearchChecker(true)
      getCategoryById(params.id, search).then((res) => {
        if (res.response) {
          return setError(res.response.data.message);
        }
        setResults(res.data);
      });
    }
  };
 
  const searchInput = (e) => {
    setSearch(e.target.value);
    if(e.target.value.length === 0 && searchChecker)
    {
      setSearchChecker(false)
      setResults(null)
      getCategoryById(params.id).then((res) => {
        if (res.response) {
          return setError(res.response.data.message);
        }
        setResults(res.data);
      });
    }
  };

  useEffect(() => {

    getCategoryById(params.id).then((res) => {
      if (res.response) {
        return setError(res.response.data.message);
      }

      document.title = 'Результаты "' +res.data.category.category+'"'
      setResults(res.data);
    });
  }, []);

  return (
    <div className="container">
      <div className="admin__results">

        <ButtonBack/>

        {!results && !error ? (
          <div style={{ position: "relative", minHeight: 120 }}>
            <CoveredBackground>
              <Loader />
            </CoveredBackground>
          </div>
        ) : error ? (
          <ErrorMessage message={error} />
        ) : !results.results.length ? (
          <>
           
            <div className="admin__retake__title">
              Категория: {results.category.category}
            </div>
            <div className="admin__retake__title">
              Сдали тест:
              <span id="result_counter">{results.results.length}</span>
            </div>
            <ErrorMessage message="Нет данных" />
          </>
        ) : (
          <>
            <Link
              to={`/admin/results-retake/${results.category.id}`}
              className="admin__results__link"
            >
              Результаты пересдачи
            </Link>
            <Link
              to={`/admin/retake-test/${results.category.id}`}
              className="admin__results__link"
            >
              Доступ на пересдачу
            </Link>
            <div className="admin__retake__title">
              Категория: {results.category.category}
            </div>
            <div className="admin__retake__title">
              Сдали тест:
              <span id="result_counter">{results.results.length}</span>
            </div>

            <input
                  type="text"
                  className="input__search"
                  placeholder="Поиск по ФИО и ИИН"
                  value={search}
                  onInput={searchInput}
                />
                <button
                  className="search__btn"
                  style={{ marginLeft: 15 }}
                  disabled={search.length <= 2 && "disabled"}
                  onClick={searchHandler}
                >
                  Найти
                </button>

            <table className="table">
              <thead>
                <tr>
                  <th>Фамилия, имя </th>
                  <th>ИИН</th>
                  <th>Аптека</th>
                  <th>Результат</th>
                  <th>Результат %</th>
                  <th>Дата</th>
                </tr>
              </thead>
              <tbody>
                {results.results.map((result) => (
                  <tr key={result.id}>
                    <td>
                      <Link to={`/admin/users/${result.user_id}/${results.category.id}/${result.id}`}>
                        {result.surname} {result.name}
                      </Link>
                    </td>
                    <td style={{ textAlign: "center" }}>{result.iin}</td>
                    <td style={{ textAlign: "center" }}>{result.ap}</td>
                    <td style={{ textAlign: "center", fontSize: 18 }}>
                      {result.current_ball}/{result.total_ball}
                    </td>
                    <td style={{ textAlign: "center", fontSize: 18 }}>
                      {(
                        (result.current_ball * 100) /
                        result.total_ball
                      ).toFixed(1)}%
                    </td>

                    <td style={{ textAlign: "center" }}>{result.date_test}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}
      </div>
    </div>
  );
};
export default ResultPage;
